import React from 'react'
import { map, get, take, size } from 'lodash'
import {
  Grid,
  Stack,
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material'


const LIMIT_OF_FAILED_PHOTO_UPLOADS_TO_LIST = 10


export const FailedPhotoUploadDialog = ({
  open,
  handleClose,
  failedPhotoUploads
}) => {

  const numFailedPhotoUploads = size(failedPhotoUploads)
  const limitOfFailedPhotoUploadsToList = take(failedPhotoUploads, LIMIT_OF_FAILED_PHOTO_UPLOADS_TO_LIST)


  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          Partial Failure
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Stack
              spacing={ 1 }
              direction='column'
              alignItems='center'
              justifyContent='flex-start'
            >
              <Typography variant='p' component='b'>
                {`${numFailedPhotoUploads} photos failed to save.`}
              </Typography>
              {map(limitOfFailedPhotoUploadsToList, (file) => (
                <Grid container>
                  <Grid item md={5}>
                    <Typography variant='p' component='b'>
                      {get(file, 'name')} failed to upload.
                    </Typography>
                  </Grid>
                </Grid>
              ))}
              {numFailedPhotoUploads > LIMIT_OF_FAILED_PHOTO_UPLOADS_TO_LIST &&
               <Typography variant='p' component='b'>
                 {`and ${numFailedPhotoUploads - LIMIT_OF_FAILED_PHOTO_UPLOADS_TO_LIST} others.`}
               </Typography>
              }
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
